<!--
  Navigation links use href instead of [routerLink] intentionally.
  Screen readers only trigger their "read full page" behavior on a real browser
  page load. Angular's SPA routing bypasses that signal entirely. Using href
  forces a hard reload on every navigation so screen readers read the new page
  from top to bottom, matching what users hear on a manual refresh.
-->
<!-- Desktop Navbar -->
<div *ngIf="!isSiteOffline" style="display: contents;">
  <div [attr.id]="isFooter ? 'footer-navbar' : 'main-navbar'" class="w-full hidden lg:block mx-auto bg-light-purple">
    <nav [attr.aria-label]="isFooter ? 'Footer desktop navigation' : 'Main navigation'">
      <div class="flex justify-center">
        <ul class="flex gap-3 text-base bg-light-purple">
          <li *ngFor="let menuItem of navbarItems; trackBy: trackByIndex"
            class="text-black mr-6 mt-[1.5rem] relative group"
            (focusout)="onMenuFocusOut($event, menuItem)"
            (keydown.escape)="closeDropdown(menuItem, $event)">

            <ng-container *ngIf="!menuItem.childItems; else dropdownMenu">
              <a [href]="menuItem.link"
                class="no-underline hover:text-gray-400 font-semibold rounded"
                [ngClass]="{ 'underline !decoration-solid !decoration-gray-400 decoration-3 text-dark-purple': isActive(menuItem.link) }"
                [attr.aria-current]="isActive(menuItem.link) ? 'page' : null">
                {{ menuItem.label }}
              </a>
            </ng-container>

            <ng-template #dropdownMenu>
              <button type="button"
                (click)="toggleDropdown(menuItem)"
                (keydown.arrowDown)="openDropdown(menuItem, $event)"
                class="font-semibold rounded cursor-pointer flex items-center bg-transparent border-0 p-0 text-black"
                [attr.aria-label]="menuItem.label"
                [attr.aria-expanded]="menuItem.open"
                [attr.aria-controls]="menuItem.open ? getSubmenuId(menuItem.label, isFooter) : null">
                {{ menuItem.label }}
                <i class="uil uil-angle-down text-md text-dark-purple ml-1" aria-hidden="true"></i>
              </button>

              <ul *ngIf="menuItem.open"
                [id]="getSubmenuId(menuItem.label, isFooter)"
                class="absolute left-0 w-48 bg-white border rounded shadow-lg z-10"
                [ngClass]="isFooter ? 'bottom-full mb-2' : 'mt-2'">
                <li *ngFor="let childItem of menuItem.childItems; trackBy: trackByIndex">
                  <a [href]="childItem.link"
                    class="block px-4 py-2 hover:bg-gray-100 no-underline text-black focus:outline-none focus:ring-2 focus:ring-dark-purple">
                    {{ childItem.label }}
                  </a>
                </li>
              </ul>
            </ng-template>
          </li>
        </ul>

        <div *ngIf="!isLoggedIn && !isFooter" class="text-black bg-light-purple">
          <button type="button"
            class="no-underline font-semibold flex ml-4 mt-[24px] bg-transparent border-0 cursor-pointer p-0 text-black"
            (click)="onLoginClick()">Log In</button>
        </div>
      </div>
    </nav>
  </div>

  <div *ngIf="isFooter" id="footer-mobile-navbar" class="w-full block lg:hidden mx-auto bg-light-purple">
    <nav aria-label="Footer navigation">
      <div class="flex justify-center">
        <ul class="flex gap-3 text-base bg-light-purple">
          <li class="text-black mt-[1.5rem] relative group">
            <a href="/contact-us" class="no-underline hover:text-gray-400 font-semibold rounded">
              Contact Us
            </a>
          </li>
        </ul>
      </div>
    </nav>
  </div>

  <!-- Mobile Menu -->
  <div *ngIf="openSideMenu" class="fixed top-0 right-0 !z-[2000] bg-white w-64 h-full shadow-lg">
    <nav aria-label="Mobile navigation">
      <div class="flex justify-end mt-10 pr-10">
        <button type="button"
          aria-label="Close menu"
          class="text-4xl uil uil-bars relative z-[2000] cursor-pointer bg-transparent border-0 p-0"
          (click)="handleSideMenuToggle()">
        </button>
      </div>

      <div class="flex items-center mt-4 px-4">
        <img [src]="iconImgUrl" class="w-6 mr-2" alt="">
        <ng-container *ngIf="!isLoggedIn; else userMenu">
          <button type="button"
            class="no-underline font-bold bg-transparent border-0 cursor-pointer p-0"
            (click)="onLoginClick()">Log in</button>
        </ng-container>
        <ng-template #userMenu>
          <details>
            <summary class="cursor-pointer font-bold">{{ userFullName }}</summary>
            <ul class="ml-4">
              <li>
                <a [href]="accountSettingsLink"
                  class="no-underline block py-1">Account Settings</a>
              </li>
            </ul>
          </details>
        </ng-template>
      </div>

      <ul class="mt-6 px-4">
        <ng-container *ngFor="let menuItem of navbarItems">
          <ng-container *ngIf="!menuItem.childItems; else mobileSubMenu">
            <li class="py-2">
              <a [href]="menuItem.link"
                class="no-underline hover:text-gray-400 font-semibold"
                [ngClass]="{ 'underline !decoration-solid !decoration-dark-purple decoration-3 text-dark-purple': isActive(menuItem.link) }">
                {{ menuItem.label }}
              </a>
            </li>
          </ng-container>

          <ng-template #mobileSubMenu>
            <li class="py-2">
              <details>
                <summary class="font-semibold cursor-pointer">{{ menuItem.label }}</summary>
                <ul class="ml-4">
                  <li *ngFor="let childItem of menuItem.childItems; trackBy: trackByIndex">
                    <a [href]="childItem.link"
                      class="no-underline block py-1">{{ childItem.label }}</a>
                  </li>
                </ul>
              </details>
            </li>
          </ng-template>
        </ng-container>

        <li *ngIf="isLoggedIn" class="py-2">
          <button type="button"
            class="no-underline hover:text-gray-400 font-semibold bg-transparent border-0 cursor-pointer p-0"
            (click)="logout()">Log Out</button>
        </li>
      </ul>
    </nav>
  </div>
</div>
